import Identity from '../../../utils/Identity'
import { StyleSheet } from 'react-native'

const useStyles = (theme) => StyleSheet.create({
  container: {
    position: 'absolute',
    right: 10,
    width: 300,
    padding: 15,
    borderRadius: 10,
    backgroundColor: theme.CARD_BACKGROUND,
    ...Identity.Shadow(theme).Card
  },
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  form: {
    marginTop: 15
  },
  button: {
    height: 30,
    padding: 0
  }
})

export default useStyles
